/** Capitalises the first letter, leaving the rest of the string alone. */
export function upperFirst(value: string): string {
  return value.length === 0 ? value : value[0].toUpperCase() + value.slice(1)
}

/**
 * Platform names arrive lowercase from the API ("discord", "steam"). They are
 * proper nouns, so they are rendered as such.
 */
export function platformName(value: string | null | undefined): string {
  return value ? upperFirst(value) : ''
}

/**
 * Capitalises the platform wherever it appears inside an already-written label.
 *
 * Objective names are stored as free text ("join Loot Drive on discord"), so
 * the proper noun only gets capitalised by `upperFirst` when it happens to land
 * first -- which it never does in that phrasing. Whole-word and
 * case-insensitive, so "Discord" and "discordant" are both left alone.
 */
export function capitalisePlatform(value: string, platform: string): string {
  if (!platform) return value
  const pattern = platform.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  return value.replace(new RegExp(`\\b${pattern}\\b`, 'gi'), platform)
}
